import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';

import {
    Grid,
    Icon,
} from '../../components';
import { projetoService, pessoaService } from '../../services';
import PrincipalMaster from '../master/Principal';

class ProjetosAvaliador extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dsProjetosAvaliados: [],
            dsProjetosAvaliar: [],
            nomeAvaliador: '',
        };
    }

    async componentWillMount() {
        await this.getProjetosAvaliados();
        await this.getFaltaAvaliar();
        if (this.props.match.params.avaliador) {
            const nome = await pessoaService.getPessoa(this.props.match.params.avaliador);
            this.setState({
                nomeAvaliador: nome.NOME,
            });
        }
    }

    async getProjetosAvaliados() {
        const projetos = await projetoService.getProjetosAvaliados(this.props.match.params.avaliador);
        this.setState({
            dsProjetosAvaliados: projetos,
        });
    }

    async getFaltaAvaliar() {
        const projetos = await projetoService.getFaltaAvaliar(this.props.match.params.avaliador);

        this.setState({ dsProjetosAvaliar: projetos });
    }

    render() {
        const {
            dsProjetosAvaliados,
            dsProjetosAvaliar,
            nomeAvaliador,
        } = this.state;

        return (
            <PrincipalMaster title="Avaliar Resumos/Projetos" {...this.props}>
                <div className="padding-content">
                    <h3>Resumos/Projetos para avaliar {nomeAvaliador ? 'do(a)' : ''} {nomeAvaliador}</h3>
                    <Grid
                        ref={(ref) => { this.projetosAvaliarGridRef = ref; }}
                        stripedRows="true"
                        textTableEmpty="Nenhum resumo/projeto para avaliar."
                        dataSource={dsProjetosAvaliar}
                        showSearch={false}
                        columnSortDefault={3}
                        sortAscDirection={false}
                        columns={[
                            {
                                text: 'Título', name: 'TITULO', allowSort: false, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Área', name: 'AREA', allowSort: false, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Evento', name: 'EVENTO', allowSort: false, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Ano', name: 'ANO', allowSort: false, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Subevento', name: 'SUBEVENTO', allowSort: false, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                name: item => (
                                    <div>
                                        <a href={`/avaliar-projeto/${item.CODIGO}`} target="_blank" rel="noopener noreferrer">
                                            <IconButton tooltip="Visualizar">
                                                <Icon name="visibility" />
                                            </IconButton>
                                        </a>
                                    </div>
                                ),
                            },
                        ]}
                    />
                    <br />
                </div>
                <div className="padding-content">
                    <h3>Resumos/Projetos já avaliados {nomeAvaliador ? 'do(a)' : ''} {nomeAvaliador}</h3>
                    <Grid
                        ref={(ref) => { this.projetosAvaliadosGridRef = ref; }}
                        stripedRows="true"
                        textTableEmpty="Nenhum resumo/projeto avaliado."
                        dataSource={dsProjetosAvaliados}
                        showSearch={false}
                        columnSortDefault={3}
                        sortAscDirection={false}
                        columns={[
                            {
                                text: 'Título', name: 'TITULO', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Área', name: 'AREA', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Evento', name: 'EVENTO', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Ano', name: 'ANO', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Subevento', name: 'SUBEVENTO', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                name: item => (
                                    <div>
                                        <a href={`/avaliar-projeto/${item.CODIGO}`} target="_blank" rel="noopener noreferrer">
                                            <IconButton tooltip="Visualizar">
                                                <Icon name="visibility" />
                                            </IconButton>
                                        </a>
                                    </div>
                                ),
                            },
                        ]}
                    />
                    <br />
                </div>
            </PrincipalMaster>
        );
    }
}

ProjetosAvaliador.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            avaliador: PropTypes.string,
        }),
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
};

export default ProjetosAvaliador;
